import { Img } from "@/components/common";

const Crease = () => (
  <>
    <div className="pointer-events-none absolute inset-y-0 left-1/2 z-10 w-[9%] -translate-x-1/2 bg-gradient-to-r from-transparent via-black/30 to-transparent" aria-hidden />
    <div className="pointer-events-none absolute inset-y-0 left-1/2 z-10 w-px bg-black/30" aria-hidden />
    <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-r from-black/10 via-transparent to-black/10" aria-hidden />
  </>
);

export const Magazine = ({ images, alt, layout = "spread", title, caption }) => (
  <div className="mx-auto w-full max-w-5xl [perspective:2000px]" data-testid="frame-magazine">
    <div
      className="relative overflow-hidden rounded-[3px] bg-[#f3f0e8] text-[#151515] shadow-[0_50px_90px_-35px_rgba(0,0,0,0.75)]"
      style={{ aspectRatio: "3/2" }}
    >
      {layout === "page" ? (
        <div className="grid h-full grid-cols-2">
          <div className="relative overflow-hidden">
            <Img src={images[0]} alt={alt} className="absolute inset-0 h-full w-full object-cover" />
          </div>
          <div className="flex flex-col justify-between p-[6%]">
            <p className="font-mono text-[clamp(6px,0.8vw,10px)] uppercase tracking-[0.3em] text-[#8a6b22]">Advertisement · Issue 09</p>
            <div>
              <h4 className="font-display text-[clamp(16px,3.4vw,48px)] leading-[0.95]">{title}</h4>
              <p className="mt-[6%] font-display text-[clamp(8px,1.15vw,16px)] leading-snug first-letter:float-left first-letter:mr-1 first-letter:text-[2.6em] first-letter:leading-[0.8]">{caption}</p>
            </div>
            <p className="font-mono text-[clamp(6px,0.8vw,10px)] tracking-[0.2em] text-black/50">— 42</p>
          </div>
        </div>
      ) : images.length > 1 ? (
        <div className="grid h-full grid-cols-2">
          {images.slice(0, 2).map((s, i) => (
            <div key={s + i} className="relative overflow-hidden">
              <Img src={s} alt={`${alt} — page ${i + 1}`} className="absolute inset-0 h-full w-full object-cover" />
            </div>
          ))}
        </div>
      ) : (
        <Img src={images[0]} alt={alt} className="absolute inset-0 h-full w-full object-cover" />
      )}
      <Crease />
    </div>
  </div>
);
